"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VdbsService = void 0;
const types_1 = require("../shared/types");
class VdbsService {
    constructor(vdbsClient) {
        this.vdbsClient = vdbsClient;
    }
    async getPlatformDetails(vin, softwareVersion = false, modGeneration = false) {
        let vdbsResponse = { acronym: types_1.DevicePlatform.UNKNOWN, softwareVersion: '', modGeneration: types_1.ModGeneration.UNKNOWN };
        if (!vin) {
            return vdbsResponse;
        }
        vdbsResponse = await this.vdbsClient.callVdbsDevicePlatformEndpoint(vin, softwareVersion, modGeneration);
        const devicePlatform = types_1.DevicePlatform[vdbsResponse === null || vdbsResponse === void 0 ? void 0 : vdbsResponse.acronym];
        if (!devicePlatform) {
            vdbsResponse.acronym = types_1.DevicePlatform.UNKNOWN;
        }
        if (softwareVersion && vdbsResponse.acronym !== types_1.DevicePlatform.WCAR) {
            vdbsResponse.softwareVersion = '';
        }
        if (modGeneration && !(vdbsResponse === null || vdbsResponse === void 0 ? void 0 : vdbsResponse.modGeneration)) {
            vdbsResponse.modGeneration = types_1.ModGeneration.UNKNOWN;
        }
        return vdbsResponse;
    }
    /**
     * @deprecated The method should not be used, see  {@link getPlatformDetails}
     */
    async getDevicePlatform(vin) {
        if (!vin) {
            return types_1.DevicePlatform.UNKNOWN;
        }
        const vdbsResponse = await this.vdbsClient.getDevicePlatform(vin);
        const devicePlatform = types_1.DevicePlatform[vdbsResponse === null || vdbsResponse === void 0 ? void 0 : vdbsResponse.acronym];
        return devicePlatform !== null && devicePlatform !== void 0 ? devicePlatform : types_1.DevicePlatform.UNKNOWN;
    }
    async getWcarSoftwareVersion(vin, devicePlatform) {
        var _a;
        if (devicePlatform !== types_1.DevicePlatform.WCAR) {
            return types_1.SoftwareVersion.UNKNOWN;
        }
        const vdbsResponse = await this.vdbsClient.getDevicePlatformWithOnlineDevices(vin);
        return this.getSoftwareVersionEnum((_a = vdbsResponse === null || vdbsResponse === void 0 ? void 0 : vdbsResponse.softwareVersion) !== null && _a !== void 0 ? _a : types_1.SoftwareVersion.UNKNOWN);
    }
    async getSoftwareVersion(vin, devicePlatform) {
        if (devicePlatform !== types_1.DevicePlatform.WCAR) {
            return '';
        }
        const vdbsResponse = await this.vdbsClient.getDevicePlatformWithOnlineDevices(vin);
        return (vdbsResponse === null || vdbsResponse === void 0 ? void 0 : vdbsResponse.softwareVersion) || '';
    }
    async getModGeneration(vin) {
        var _a;
        if (!vin) {
            return types_1.ModGeneration.UNKNOWN;
        }
        const vdbsResponse = await this.vdbsClient.getModGeneration(vin);
        if (!(vdbsResponse === null || vdbsResponse === void 0 ? void 0 : vdbsResponse.modGeneration) || !Object.values(types_1.ModGeneration).includes(vdbsResponse.modGeneration)) {
            return types_1.ModGeneration.UNKNOWN;
        }
        if ((vdbsResponse === null || vdbsResponse === void 0 ? void 0 : vdbsResponse.modGeneration) && ((_a = vdbsResponse === null || vdbsResponse === void 0 ? void 0 : vdbsResponse.modGeneration) === null || _a === void 0 ? void 0 : _a.length)) {
            return vdbsResponse.modGeneration;
        }
        return types_1.ModGeneration.UNKNOWN;
    }
    getSoftwareVersionEnum(softwareVersion) {
        if (softwareVersion.startsWith('0.')) {
            return types_1.SoftwareVersion.ME0;
        }
        if (softwareVersion.startsWith('1.')) {
            return types_1.SoftwareVersion.ME1;
        }
        if (softwareVersion.startsWith('2.')) {
            return types_1.SoftwareVersion.ME2;
        }
        return types_1.SoftwareVersion.UNKNOWN;
    }
}
exports.VdbsService = VdbsService;
//# sourceMappingURL=VdbsService.js.map